<script>
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import DatePicker from "vue3-persian-datetime-picker";
import Swals from "@/assets/js/Swals";
import FreeWorld from "@/assets/js/FreeWorld";
import persianDate from "persian-date";

export default {
  name: "AddAuctions",
  components:{DatePicker, LoadingPage},
  setup(){

    let loading = ref(false)

    let guilds = ref({
      all: [],
      select: null
    })
    let one_category = ref({
      all: [],
      select: null,
    })
    let two_category = ref({
      all: [],
      select: null,
    })
    let products = ref({
      all: [],
      select: null,
      unit: null,
      brand: null,
    })

    let data_bid = ref({
      pid: null,
      pnum: '',
      start_date: null,
      price: '',
      price_step: '',
    })


    function get_guilds() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'all_guild'}, 'info').then((res) => {

        loading.value = false
        guilds.value.all = res.data
        guilds.value.select = res.data[0].id

        try {
          if (guilds.value.all[0]) {
            one_category.value.all = guilds.value.all[0].category
            if (one_category.value.all[0]) {
              one_category.value.select = one_category.value.all[0].id
              two_category.value.all = one_category.value.all[0].subcategory
              if (two_category.value.all[0]) {
                two_category.value.select = two_category.value.all[0].id
                products.value.all = two_category.value.all[0].products
                if (products.value.all[0]) {
                  products.value.select = products.value.all[0].id
                  products.value.brand = products.value.all[0].brand
                  products.value.unit = products.value.all[0].unit
                } else {
                  products.value.select = null
                  products.value.brand = null
                  products.value.unit = null
                }
              }
            }
          }
        }
        catch (e) {
          console.log(e.message)
        }


      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_guilds, true)
      })
    }
    get_guilds()

    function chang_category(type) {

      switch (type) {
        case 'guild' :
          guilds.value.all.forEach((item) => {
            if (item.id === guilds.value.select) {
              one_category.value.all = item.category
              if (one_category.value.all[0]) {
                one_category.value.select = one_category.value.all[0].id
                two_category.value.all = one_category.value.all[0].subcategory
                if (two_category.value.all[0]) {
                  two_category.value.select = two_category.value.all[0].id
                  products.value.all = two_category.value.all[0].products
                  if (products.value.all[0]) {
                    products.value.select = products.value.all[0].id
                    products.value.brand = products.value.all[0].brand
                    products.value.unit = products.value.all[0].unit
                  } else {
                    products.value.select = null
                    products.value.brand = null
                    products.value.unit = null
                  }

                }else {
                  two_category.value.all = []
                  two_category.value.select = null
                  products.value.all = []
                  products.value.select = null
                  products.value.brand = null
                  products.value.unit = null
                }

              }else{
                one_category.value.select = null
                two_category.value.all = []
                two_category.value.select = null
                products.value.all = []
                products.value.select = null
                products.value.brand = null
                products.value.unit = null
              }
            }
          })
          break;

        case 'one_cat' :
          one_category.value.all.forEach((item) => {
            if (item.id === one_category.value.select) {
              two_category.value.all = item.subcategory
              if (two_category.value.all[0]) {
                two_category.value.select = two_category.value.all[0].id
                products.value.all = two_category.value.all[0].products
                if (products.value.all[0]) {
                  products.value.select = products.value.all[0].id
                  products.value.brand = products.value.all[0].brand
                  products.value.unit = products.value.all[0].unit
                } else {
                  products.value.select = null
                  products.value.brand = null
                  products.value.unit = null
                }
              }
            }
          })
          break;

        case 'two_cat' :
          two_category.value.all.forEach((item) => {
            if (item.id === two_category.value.select) {
              products.value.all = item.products
              if (products.value.all[0]) {
                products.value.select = products.value.all[0].id
                products.value.brand = products.value.all[0].brand
                products.value.unit = products.value.all[0].unit
              } else {
                products.value.select = null
                products.value.brand = null
                products.value.unit = null
              }
            }
          })
          break;

        case 'product' :
          products.value.all.forEach((item) => {
            if (item.id === products.value.select) {
              products.value.unit = item.unit
              products.value.brand = item.brand
            }
          })
          break;

        case 'edit' :
          guilds.value.all.forEach((item)=>{
            if (item.id == guilds.value.select){
              one_category.value.all = item.category
              item.category.forEach((item_cat)=>{
                if (item_cat.id == one_category.value.select){
                  two_category.value.all = item_cat.subcategory
                  item_cat.subcategory.forEach((item_sub_cat)=>{
                    if (item_sub_cat.id == two_category.value.select){
                      products.value.all = item_sub_cat.products
                      item_sub_cat.products.forEach((item_prod)=>{
                        if (item_prod.id == products.value.select){
                          products.value.brand = item_prod.brand
                          products.value.unit = item_prod.unit
                        }
                      })
                    }
                  })
                }
              })
            }
          })
          break;

      }

    }

    function add_bid() {

      data_bid.value.pid = products.value.select

      if (data_bid.value.pid === null){Swals.Warning('لطفا محصول مورد نظر خود را انتخاب کنید!');return false}
      if (data_bid.value.pnum.length === 0){Swals.Warning('لطفا حجم مورد نظر خود را وارد کنید!');return false}
      if (data_bid.value.start_date === null){Swals.Warning('لطفا تاریخ شروع مزایده را مشخص کنید!');return false}
      if (data_bid.value.price.length === 0){Swals.Warning('لطفا قیمت پایه مزایده را مشخص کنید!');return false}
      if (data_bid.value.price_step.length === 0){Swals.Warning('لطفا قیمت هر گام مزایده را مشخص کنید!');return false}

      //مقایسه تاریخ انتخاب شده با تاریخ الان
      let now = new Date();
      let persianNow = new persianDate(now);
      persianNow.formatPersian = false;
      let time_new = persianNow.format('YYYY-MM-DD HH:mm:00');

      if (data_bid.value.start_date < time_new){Swals.Warning('لطفا تاریخ و ساعت مزایده را به صورت صحیح انتخاب کنید!');return false}

      loading.value = true
      FreeWorld.Heisenberg(data_bid.value , 'shop/add_bid' , true).then((res)=>{

        loading.value = false
        if (res.data.status === 'ok'){
          Swals.Done('مزایده شما با موفقیت ثبت شد' , 'MyAuctions')
        }else {
          Swals.Fault('متاسفانه مزایده شما ثبت نشد' , 'MyAuctions')
        }

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , add_bid)
      })

    }

    return{

      guilds,
      one_category,
      two_category,
      products,
      loading,
      chang_category,
      data_bid,
      add_bid,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">افزودن مزایده</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="p-body w-100 ">
      <div class="mt-3">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">انتخاب صنف</p>
        <select v-model="guilds.select" @change="chang_category('guild')"
                class="text-center font-4 bg-white w-100 shadow-custom py-3 px-1 rounded-4">
          <option v-for="item in guilds.all" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">انتخاب سطح اول دسته بندی محصول</p>
        <select v-model="one_category.select" @change="chang_category('one_cat')"
                class="text-center font-4 bg-white w-100 shadow-custom py-3 px-1 rounded-4">
          <option v-for="item in one_category.all" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">انتخاب سطح دوم دسته بندی محصول</p>
        <select v-model="two_category.select" @change="chang_category('two_cat')"
                class="text-center font-4 bg-white w-100 shadow-custom py-3 px-1 rounded-4">
          <option v-for="item in two_category.all" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">انتخاب محصول</p>
        <select v-model="products.select" @change="chang_category('product')"
                class="text-center font-4 bg-white w-100 shadow-custom py-3 px-1 rounded-4">
          <option v-for="item in products.all" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">واحد محصول</p>

        <div class="shadow-custom bg-white font-5 rounded-4 w-100 py-3 px-2 text-center">
          <p v-if="products.unit !== null" class="animate__animated animate__fadeIn">{{ products.unit }}</p>
          <p v-else class="animate__animated animate__fadeIn">محصول مورد نظر را انتخاب کنید</p>
        </div>
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">انتخاب برند محصول</p>

        <div class="shadow-custom bg-white font-5 rounded-4 w-100 py-3 px-2 text-center">
          <p v-if="products.brand !== null" class="animate__animated animate__fadeIn">{{ products.brand }}</p>
          <p v-else class="animate__animated animate__fadeIn">محصول مورد نظر را انتخاب کنید</p>
        </div>
      </div>

      <div class="mt-4">
        <p class="me-2 mb-2 font-bold font-color d-flex align-items-center">
          <span class="font-4">حجم محصول</span>
          <span class="font-6 mr-1">(تعداد یا حجم بر مبنای واحد محصول)</span>
        </p>

        <input v-model="data_bid.pnum" class="text-center bg-white font-4 w-100 shadow-custom py-3 px-1 rounded-4" placeholder="مثلا 200">
      </div>

      <div class="mt-4">
        <p class="me-2 mb-2 font-bold font-color d-flex align-items-center">
          <span class="font-4">تاریخ شروع مزایده</span>
          <span class="font-6 mr-1">(مزایده از این تاریخ به مدت 72 ساعت فعال می باشد)</span>
        </p>

        <div class="shadow-custom bg-white font-4 rounded-4 w-100 py-3 px-2 text-center">
          <date-picker class="text-center border-0" v-model="data_bid.start_date" type="datetime" placeholder="تاریخ شروع مزایده" format="jYYYY-jMM-jDD HH:mm:00" display-format="jYYYY/jMM/jDD  HH:mm" ></date-picker>
        </div>
      </div>

      <div class="mt-4">
        <div class="d-flex justify-space-between align-items-center">
        <p class="me-2 mb-2 font-bold font-color font-4 d-flex align-items-center">قیمت پایه مزایده</p>
          <p v-if="data_bid.price> 0" class="font-4 font-bold font-color-green">
            <span class="">{{ parseInt(data_bid.price).toLocaleString() }}</span>
            <span class="mr-1">تومان</span>
          </p>
        </div>

        <input v-model="data_bid.price" class="text-center bg-white font-4 w-100 shadow-custom py-3 px-1 rounded-4" type="number" placeholder="تومان">
      </div>

      <div class="mt-4">
        <div class="d-flex justify-space-between align-items-center">
          <p class="me-2 mb-2 font-bold font-color font-4 d-flex align-items-center">قیمت هر گام</p>
          <p v-if="data_bid.price_step > 0" class="font-4 font-bold font-color-green">
            <span class="">{{ parseInt(data_bid.price_step).toLocaleString() }}</span>
            <span class="mr-1">تومان</span>
          </p>
        </div>

        <input v-model="data_bid.price_step" class="text-center bg-white font-4 w-100 shadow-custom py-3 px-1 rounded-4" type="number" placeholder="تومان">
      </div>


      <v-btn @click="add_bid" class="py-3 h-100 my-4 w-100 border-0 rounded-3 bg-color text-white">تبت نهایی</v-btn>

    </div>


  </div>

</template>


<style scoped>

</style>